import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getCheck: {
        method: 'GET',
        url: `${BASE_PATH_API}/checks/:id`
    },
    addCheck: {
        method: 'POST',
        url: `${BASE_PATH_API}/checks/add`
    },
    updateCheck: {
        method: 'PUT',
        url: `${BASE_PATH_API}/checks/:id`
    },
    deleteCheck: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/checks/:id`
    },
    voidCheck: {
        method: 'PUT',
        url: `${BASE_PATH_API}/checks/:id/void`
    },
    getBillsForCheck: {
        method: 'GET',
        url: `${BASE_PATH_API}/checks/:id/bills`
    },
    getCheckPayee: {
        method: 'GET',
        url: `${BASE_PATH_API}/checks/payee/:userId`
    },
    getCheckPayeeAddress: {
        method: 'GET',
        url: `${BASE_PATH_API}/checks/payee/:userId/address`
    },
    getDuplicateCheck: {
        method: 'GET',
        url: `${BASE_PATH_API}/checks/duplicate?glBankAccountId?journalId?checkNumber`
    },
    getTransactionsForCheckNumber: {
        method: 'GET',
        url: `${BASE_PATH_API}/checks/search?bankGlAccountId?checkNumber?searchType`
    }
};

export function ChecksApi() {
    return createActions(actions);
}
